import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    textOff: { type: String, default: "" },
    textOn: { type: String, default: "" },
    text: { type: String, default: "" },
    textState: { type: String, default: "" },
    position: { type: String, default: "top" },
    absolute:  { type: Boolean, default: true }
  };

  connect() {
    const isOpen = this.element.getAttribute("aria-expanded") === "true";
    this.updateTooltipText({ detail: { isOpen } });
  }

  show() {
    this.createTooltip();
  }

  hide() {
    this.removeTooltip();
  }

  createTooltip() {
    if (this.tooltip || !this.textStateValue) return;

    this.tooltip = document.createElement("div");
    this.tooltip.innerHTML = this.textStateValue;
    this.tooltip.style.zIndex = "1001"
    this.tooltip.className = `text-xs rounded py-1 mt-2 opacity-0 duration-200 text-left bg-primary text-white shadow-md px-2 ${ this.absoluteValue ? "absolute" : "block"}`;
    this.element.appendChild(this.tooltip);

    const elementRect = this.element.getBoundingClientRect();

    switch (this.positionValue) {
      case "top":
        this.tooltip.style.bottom = `${elementRect.height + 5}px`;
        break;

      case "bottom":
        this.tooltip.style.top = `${elementRect.height + 5}px`;
        break;

      case "left":
        this.tooltip.style.top = `${elementRect.height - 25}px`;
        this.tooltip.style.left = `${elementRect.width + 5}px`;
        break;

      case "right":
        this.tooltip.style.top = `${elementRect.height - 25}px`;
        this.tooltip.style.right = `${elementRect.width + 5}px`;
        break;

      default:
        console.warn(`Tooltip position "${this.positionValue}" is not valid.`);
    }

    this.tooltip.classList.add("visible", "opacity-100");
  }

  removeTooltip() {
    if (this.tooltip) {
      this.tooltip.remove();
      this.tooltip = null;
    }
  }

  updateTooltipText(event) {
    this.toggleText(event.detail.isOpen);
  }

  toggleText(isOpen) {
    this.textStateValue = this.textValue || (isOpen ? this.textOnValue : this.textOffValue);
    this.element.setAttribute("data-tooltip-text-state-value", this.textStateValue);
  }
}
